import {
  trans, ADD_MEDIA_ERROR, MAX_FILES_UPLOAD_ERROR, FILE_SIZE_ERROR, IMAGES, VIDEOS, AUDIO, PDF, SPREADSHEET
} from '../../../translator'

let validationResponseObject = { title: trans(ADD_MEDIA_ERROR, {}, 'reports'), isValid: true, errorMessage: '' }

let fileValidator

const initialiseFileValidator = (imageMaxSize, videoMaxSize, audioMaxSize, pdfMaxSize, spreadsheetMaxSize) => {
  fileValidator = {
    image: { label: trans(IMAGES, {}, 'reports'), uploadMaxSize: imageMaxSize },
    video: { label: trans(VIDEOS, {}, 'reports'), uploadMaxSize: videoMaxSize },
    audio: { label: trans(AUDIO, {}, 'reports'), uploadMaxSize: audioMaxSize },
    pdf: { label: trans(PDF, {}, 'reports'), uploadMaxSize: pdfMaxSize },
    spreadsheet: { label: trans(SPREADSHEET, {}, 'reports'), uploadMaxSize: spreadsheetMaxSize }
  }
}

const validateFileUploadCount = (totalFilesCount) => {
  const maxFilesToUploadCount = 20

  if (maxFilesToUploadCount < (totalFilesCount)) {
    validationResponseObject.isValid = false
    validationResponseObject.errorMessage = trans(MAX_FILES_UPLOAD_ERROR, { '%max_files%': maxFilesToUploadCount }, 'reports')
  }

  return validationResponseObject
}

const validateFileSize = (file) => {
  const fileExtension = file.name.split('.').pop()
  const fileType = getFileType(fileExtension)

  if (typeof fileType !== 'undefined') {
    validationResponseObject = validateFileByFileType(file, fileType)
  }

  return validationResponseObject
}

const getFileType = (fileExtension) => {
  if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
    return 'image'
  }

  if (['mov', 'mp4', 'mpg', '3gp'].includes(fileExtension)) {
    return 'video'
  }

  if (['mp3', 'wav', 'opus', 'm4a'].includes(fileExtension)) {
    return 'audio'
  }

  if (['pdf'].includes(fileExtension)) {
    return 'pdf'
  }

  if (['xls', 'xlsx', 'numbers', 'csv'].includes(fileExtension)) {
    return 'spreadsheet'
  }

  // undefined means that file type is by default accepted and there is no validation for it -- existing logic
  return undefined
}

function formatBytes (bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

const validateFileByFileType = (file, fileType) => {
  if (file.size > fileValidator[fileType].uploadMaxSize) {
    validationResponseObject.isValid = false
    validationResponseObject.errorMessage = trans(FILE_SIZE_ERROR, { '%file_type%': fileValidator[fileType].label, '%max_size%': formatBytes(fileValidator[fileType].uploadMaxSize) }, 'reports')
  } else {
    validationResponseObject.isValid = true
  }

  return validationResponseObject
}

export { initialiseFileValidator, validateFileSize, validateFileUploadCount }
